import { useMobileView } from "./useMobileView";

export function useScrollOffset() {
  const isMobileView = useMobileView();
  return isMobileView ? -91 : -113;
}
